import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import WorkHoursTable from './WorkHoursTable';
import Performance from './Performance';
import '../Css/Driver.css';
import '../Css/OrderExcel.css';
import Navbar from './Navbar';

const Driver = () => {
    const [selectedOption, setSelectedOption] = useState('workHours');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date());

    const handleClick = (option) => {
        setSelectedOption(option);
    };

    return (
        <div className="drivers-page">
            <Navbar />
            <div className="driversToolbar">
                <h2 className="headS">
                    <Link to="/Reports" className="reports">Reports</Link>
                    <span className="crumbSep">{">"}</span>
                    <span className="reporter">Drivers</span>
                </h2>
                {selectedOption === 'workHours' && (
                    <div className="driversFilters">
                        <input
                            type="text"
                            className="searchbarrs"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoComplete="off"
                        />
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            dateFormat="yyyy-MM-dd"
                            className="dropdownO"
                        />
                    </div>
                )}
            </div>

            <p className="optionS">
                <span
                    className={`option ${selectedOption === 'workHours' ? 'selected' : ''}`}
                    onClick={() => handleClick('workHours')}
                >
                    Work Hours
                </span>
            </p>
            {selectedOption === 'workHours' && (
                <WorkHoursTable
                    searchTerm={searchTerm}
                    selectedDate={selectedDate}
                />
            )}
            {selectedOption === 'driverPerformance' && <Performance />}
        </div>
    );
};

export default Driver;
